import React, { useState } from 'react';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { sendEmail } from '../Services/ContactUs.service';

const ContactUsFormComponent = (props) => {
  const { formData, subjects, labelList, googleReCaptchaProps } = props;
  const { executeRecaptcha } = googleReCaptchaProps;
  const contactUsForm = formData.contactUsForm;
  const [statusMessage, setStatusMessage] = useState();
  const [successMessageHeader, setSuccessMessageHeader] = useState();
  const [successMessageDescription, setSuccessMessageDescription] = useState();

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!executeRecaptcha) {
      console.error('Execute recaptcha not yet available');
      return;
    }
    executeRecaptcha('contactUs').then((token) => {
      contactUsForm.token = token;
      sendEmail({
        ...formData,
        contactUsForm,
      })
        .then((value) => value.json())
        .then((statusMsg) => {
          if (statusMsg && statusMsg.length > 0) {
            setSuccessMessageHeader(statusMsg[0]);
            setSuccessMessageDescription(statusMsg[1]);
          }
          setStatusMessage(undefined);
        })
        .catch(async (error) => {
          if (error && error.response) {
            const body = await error.response.json();
            if (
              body &&
              body.modelState &&
              body.modelState.statusMessage &&
              body.modelState.statusMessage.length > 0
            ) {
              setStatusMessage(body.modelState.statusMessage[0]);
            }
          }
        });
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      {!successMessageHeader ? (
        <div className="fieldgroup customer-fieldgroup">
          <div className="small-12 medium-6">
            <label
              className="form__label"
              htmlFor="ContactUsForm_Name"
              required={true}
            >
              {labelList.name}
            </label>
            <input
              autoComplete="name"
              className="form__input"
              id="ContactUsForm_Name"
              name="ContactUsForm.Name"
              required={true}
              type="text"
              value={contactUsForm.name}
              onChange={(event) =>
                (contactUsForm.name = event.currentTarget.value)
              }
            />
          </div>
          <div className="small-12 medium-6">
            <label
              className="form__label"
              htmlFor="ContactUsForm_Phone"
              required={true}
            >
              {labelList.phone}
            </label>
            <input
              autoComplete="phone"
              className="form__input"
              id="ContactUsForm_Phone"
              name="ContactUsForm.Phone"
              type="text"
              value={contactUsForm.phone}
              onChange={(event) =>
                (contactUsForm.phone = event.currentTarget.value)
              }
            />
          </div>
          <div className="small-12 medium-6">
            <label
              className="form__label"
              htmlFor="ContactUsForm_Email"
              required={true}
            >
              {labelList.email}
            </label>
            <input
              autoComplete="email"
              className="form__input"
              id="ContactUsForm_Email"
              name="ContactUsForm.Email"
              required={true}
              type="email"
              value={contactUsForm.email}
              onChange={(event) =>
                (contactUsForm.email = event.currentTarget.value)
              }
            />
          </div>
          <div className="small-12">
            <label
              className="form__label"
              htmlFor="ContactUsForm_Subject"
              required={true}
            >
              {labelList.subject}
            </label>
            <select
              id="ContactUsForm_Subject"
              name="ContactUsForm.Subject"
              value={contactUsForm.subject}
              onChange={(event) =>
                (contactUsForm.subject = event.currentTarget.value)
              }
            >
              {subjects.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.text}
                </option>
              ))}
            </select>
          </div>

          <div className="small-12">
            <label
              className="form__label"
              htmlFor="ContactUsForm_HowToContact"
              required={true}
            >
              {labelList.howToContact}
            </label>
            <input
              autoComplete="name"
              className="form__input"
              id="ContactUsForm_HowToContact"
              name="ContactUsForm.HowToContact"
              type="text"
              value={contactUsForm.howToContact}
              onChange={(event) =>
                (contactUsForm.howToContact = event.currentTarget.value)
              }
            />
          </div>

          <div className="small-12">
            <label
              className="form__label"
              htmlFor="ContactUsForm_Message"
              required={true}
            >
              {labelList.message}
            </label>
            <textarea
              className="form__input"
              cols="20"
              id="ContactUsForm_Message"
              name="ContactUsForm.Message"
              rows="2"
              value={contactUsForm.message}
              onChange={(event) =>
                (contactUsForm.message = event.currentTarget.value)
              }
            />
          </div>

          <fieldset className="small-12">
            <input
              className="button contact-us-schema__submit-button"
              type="submit"
              value={labelList.submit}
            />
          </fieldset>
        </div>
      ) : (
        <div>
          <p className="contact-us-schema__status-message">
            <strong>{successMessageHeader}</strong>
            <br />
            {successMessageDescription}
          </p>
        </div>
      )}

      {statusMessage ? (
        <div className="contact-us-schema__status-message">
          <div data-alert className="alert alert-box">
            {statusMessage}
          </div>
        </div>
      ) : null}
    </form>
  );
};

export default withGoogleReCaptcha(ContactUsFormComponent);
